<template lang="pug">
    div
        div.toolbar
            div.line
                h1.title Реестр
            div.line
                form.search.search--rounded
                    input(type="search" placeholder="")



        div.content
            //.resstr - твблица на дивах с обоими типами строк: обычными и раскрвающимися
            div.table.reestr
                div.table-head
                    div
                        div.flex-table
                            div.sortable.text Муниципальное образование
                            div.sortable.arrows
                                span.up
                                span.down
                    div
                        div.flex-table
                            div.sortable.text ОКАТО
                            div.sortable.arrows
                                span.up
                                span.down
                    div
                        div.flex-table
                            div.sortable.text ОКТМО
                            div.sortable.arrows
                                span.up
                                span.down
                    div
                        div.flex-table
                            div.sortable.text Население
                            div.sortable.arrows
                                span.up
                                span.down
                    div
                        div.flex-table
                            div.sortable.text Управленческий округ
                            div.sortable.arrows
                                span.up
                                span.down
                    //div
                div.table-body
                    div.item
                        div
                            span.arrow
                            a(href="#/verstka/reestrCard") Артемовский городской округ
                        div 123
                        div 123
                        div 123
                        div 123
                    div.item.close
                        div
                            span.arrow
                            span Артемовский городской округ
                        div 123
                        div 123
                        div 123
                        div 123
                    div.item.first-level.open
                        div
                            span.arrow
                            a(href="#/verstka/reestrCard") Артемовский городской округ
                        div 123
                        div 123
                        div 123
                        div 123
                    div.item.second-level
                        div
                            span.arrow
                            span Артемовский городской округ
                        div 123
                        div 123
                        div 123
                        div 123
                    div.item.second-level
                        div
                            span.arrow
                            span Артемовский городской округ
                        div 123
                        div 123
                        div 123
                        div 123



        div.footer-nav
            div.actions-filter-panel
                button.actions-filter-panel__button.default.download Скачать
            div.paginator
                span Показывать по
                select
                    option 10
                    option 25
                    option 50
                    option 100
                div.page-nav
                    span.navigate.prev
                    input(type='text')
                    span из ?
                    span.navigate.next


</template>

<script>
  export default {};
</script>
